// CONFIG
export const CONFIG_URI = "/config";
export const OIDC_LOGOUT_URI = "/loggedout";

// OIDC
export const OIDC_CALLBACK_URI = "/callback";

export const OIDC_SILENT_RENEW_URI = "/oidc-silent-renew";
export const OIDC_SCOPE = "openid stanlab_read stanlab_write";
export const OIDC_RESPONSE_TYPE = "code";
export const OIDC_EXPIRING_NOTIF_TIME = 120;

// Ukendt Organisation VAT
export const UKENDT_ORGANIZATION = "99999999";
export const UKENDT_ORGANIZATION_EU = "99999998";
export const UKENDT_ORGANIZATION_NON_EU = "99999997";
